import React, { useMemo } from 'react';
import { observer } from 'mobx-react-lite';

export const QuickBetsContent = observer(
  ({ marketData, selectedMarket, setSelectedMarket, activeFreeBet, activeTabIndex }) => {
    const tabHeaderContent = useMemo(() => {
      const marketOdd = marketData.map((el) => el.odd);
      return [...new Set(marketOdd)];
    }, [marketData.length]);

    const getBetType = (value) => {
      if (value.indexOf('_') < 0) {
        return value;
      }
      return value.split('_')[1];
    };

    return (
      <div className='mob-game-btn-block-more'>
        <div className='block-more-h'>
          {tabHeaderContent.map((tabItem, idx) => (
            <p className='block-more-h-p' key={`${tabItem}_${idx}`}>
              x{tabItem}
            </p>
          ))}
        </div>
        <div className='block-more-btn-wrp'>
          {marketData.map((typeData) => {
            return (
              <div className='block-more-btn-row' key={typeData.marketType}>
                <div
                  className={`block-more-btn-row-item type${activeTabIndex} ${
                    selectedMarket.marketType === typeData.marketType ? 'active' : ''
                  } ${activeFreeBet.id && activeFreeBet.minOdd > typeData.odd ? 'disabled' : ''}`}
                  onClick={() => setSelectedMarket({ ...typeData, hiOrLo: null })}
                >
                  <p className='block-more-btn-row-item-p'>{getBetType(typeData.betType)}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    );
  }
);
